const API_URL = process.env.REACT_APP_API_URL;
const PROJECT = process.env.REACT_APP_PROJECT;
const TYPE = process.env.REACT_APP_TYPE ?? '';
const COOKIE_PREFIX = TYPE ? `${PROJECT}-${TYPE}` : PROJECT;
const ENVIRONMENT = process.env.REACT_APP_ENV;
const ENVIRONMENT_DEV = process.env.REACT_APP_ENV === 'dev';
const LANGUAGE_CODE = 'ru-RU';
const BUILD_TARGET = process.env.BUILD_TARGET;
export { API_URL, PROJECT, ENVIRONMENT, ENVIRONMENT_DEV, LANGUAGE_CODE, BUILD_TARGET, COOKIE_PREFIX };